import { computed, inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@lib/shared/data-access';
import { ReportNumberGenerationModel } from '@lib/report-number-generation/models';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportNumberGenerationService {
  private httpClient = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  // signals
  private editReportNumberSourceSignal = signal<ReportNumberGenerationModel | null>(null);
  public editReportNumberComputedSignal = computed(() => { return this.editReportNumberSourceSignal() });

  private reportNumberSourceSignal = signal<ReportNumberGenerationModel[]>([]);
  public reportNumberComputedSignal = computed(() => { return this.reportNumberSourceSignal() });
      
  public generateReportNumber(typeId: number) {
    return this.httpClient.get<string>(
      this.environmentService
        .pathfinderApiUrl
        .concat(`/api/v1/report-number-generation/${typeId}`),
      {
        responseType: 'text' as 'json',
      }
    );
  }

  public getReportNumberFormat(typeId: number) {
    return this.httpClient.get<string>(
      this.environmentService
        .pathfinderApiUrl
        .concat(`/api/v1/report-number-generation/${typeId}/format`),
      {
        responseType: 'text' as 'json',
      }
    );
  }

  public getNonSystemDefinedReportNumbers() {
    return this.httpClient
      .get<ReportNumberGenerationModel[]>(
        this.environmentService
          .pathfinderApiUrl
          .concat(`/api/v1/report-number-generation/report-numbers`)
      ).pipe(
        tap((reportnumbers) => {
          this.reportNumberSourceSignal.set(reportnumbers)
        })
      );
  }

  public getNonSystemDefinedReportNumbersByOrganizationId(organizationId: number) {
    return this.httpClient
      .get<ReportNumberGenerationModel[]>(
        this.environmentService
          .pathfinderApiUrl
          .concat(`/api/v1/report-number-generation/report-numbers/organizations/${organizationId}`)
      ).pipe(
        tap((reportnumbers) => {
          this.reportNumberSourceSignal.set(reportnumbers)
        })
      );
  }

  public saveReportNumber(reportNumber: ReportNumberGenerationModel) {
    return this.httpClient
        .put<ReportNumberGenerationModel>(
            `${this.environmentService.pathfinderApiUrl}/api/v1/report-number-generation/report-numbers`, reportNumber
        )
        .pipe(
            tap((response) => {
                this.reportNumberSourceSignal.update(reportnumbers => {
                    const existingReportNumber = reportnumbers.find(reportNumber => reportNumber.id === response.id);
                    if (existingReportNumber) {
                        return reportnumbers.map(reportNumber => reportNumber.id === response.id ? response : reportNumber);
                    } else {
                        return [...reportnumbers, response];
                    }
                });
            })
        );
}


  // signals

  public setEditReportNumberConfiguration(code: ReportNumberGenerationModel | null) {
    this.editReportNumberSourceSignal.set(code);
}
}
